import { Helmet } from 'react-helmet-async';
// @mui
import { styled } from '@mui/material/styles';
import { Container, Typography } from '@mui/material';
// components
import ResetPasswordForm from '../sections/auth/resetPassword/ResetPasswordForm';

// ----------------------------------------------------------------------

const StyledRoot = styled('div')(({ theme }) => ({
    [theme.breakpoints.up('md')]: {
        display: 'flex',
    },
}));

const StyledContent = styled('div')(({ theme }) => ({
    maxWidth: 480,
    margin: 'auto',
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

export default function ResetPasswordPage() {

    return (
        <>
            <Helmet>
                <title>Reset Password</title>
            </Helmet>

            <StyledRoot>
                <Container maxWidth="sm">
                    <StyledContent>
                        <Typography variant="h4" gutterBottom>
                            Reset Password
                        </Typography>
                        <ResetPasswordForm />
                    </StyledContent>
                </Container>
            </StyledRoot>
        </>
    );
}
